const MIN_LENGTH = 10;
const CONCURRENCY = 4;
const TIMEOUT_MS = 4000;

export async function detectLanguage(text, endpoint) {
  if (!text || text.trim().length < MIN_LENGTH) return null;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URl}/${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text }),
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    if (!response.ok) return null;

    const { result } = await response.json();
    return { languageCode: result?.LanguageCode ?? null, score: result?.Score ?? null };
  } catch {
    clearTimeout(timeoutId);
    return null;
  }
}

export async function detectAllLanguages(textAnswers, endpoint) {
  const entries = Object.entries(textAnswers).filter(
    ([, v]) => v && typeof v === 'string' && v.trim().length >= MIN_LENGTH,
  );

  if (entries.length === 0) return {};

  const results = {};
  const valueCache = new Map();

  for (let i = 0; i < entries.length; i += CONCURRENCY) {
    const batch = entries.slice(i, i + CONCURRENCY);
    await Promise.all(
      batch.map(async ([fieldId, value]) => {
        if (valueCache.has(value)) {
          results[fieldId] = valueCache.get(value);
          return;
        }
        const result = await detectLanguage(value, endpoint);
        results[fieldId] = result;
        valueCache.set(value, result);
      }),
    );
  }

  return results;
}
